"use strict";
/*!
 *
 *  gallery.ts
 *
 */
var gallery = /** @class */ (function () {
    function gallery(elem, option) {
        this.setting = {
            main: 'gallery_main',
            thumb: 'gallery_thumb'
        };
        this.$gallery = $(elem);
        this.setting = $.extend({}, this.setting, option);
        this.$main = this.$gallery.children(this.setting.main);
        this.$thumb = this.$gallery.children(this.setting.thumb);
        this.buildThumb();
        this.buildSlick();
    }
    gallery.prototype.buildThumb = function () {
        var _this = this;
        this.$main.find('img').each(function (i, elem) {
            var $item = $('<div class="' + _this.setting.thumb.replace(/\./, '') + '_item" />');
            $item.append($(elem).clone());
            _this.$thumb.append($item);
        });
    };
    gallery.prototype.buildSlick = function () {
        this.$main.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            fade: true,
            asNavFor: this.setting.thumb
        });
        this.$thumb.slick({
            slidesToShow: 6,
            slidesToScroll: 1,
            arrows: false,
            asNavFor: this.setting.main,
            centerMode: true,
            focusOnSelect: true
        });
    };
    return gallery;
}());
;
$.fn.gallery = function (option) {
    return this.each(function (i, elem) {
        var opt = option ? option : {};
        new gallery(elem, opt);
    });
};
